const Util = require('./util')

let queue = []
// 函数节流
function _throttle(action, delay, context) {
  let timeout = null
  let lastRun = 0
  context = context || this
  return function () {
    if (timeout) {
      return
    }
    let elapsed = Date.now() - lastRun
    let args = arguments
    let runCallback = function () {
      lastRun = Date.now()
      timeout = false
      action.apply(context, args)
    }
    if (elapsed >= delay) {
      runCallback()
    }
    else {
      timeout = setTimeout(runCallback, delay)
    }
  }
}

// 滚动
window.addEventListener('scroll', _throttle(_action, 200))

function _action() {
	queue = queue.filter((fn,index)=>{
		return !(fn())
	})
}

// 操作句柄
function _hander(dom, cb, threshold) {
	if (Util.checkInView(dom)) {
    	cb && cb()
    	return true
    }
    return false
}

function _exposeAction(dom, cb, threshold) {
  	queue.push(function() {
			return _hander(dom, cb, threshold)
  	})
  	_action()
}

function viewPush(dom, cb, threshold = 0) {
	if(!dom || !dom.getBoundingClientRect) {
		return 
	}
	_exposeAction(dom, cb, threshold)
}

module.exports = viewPush


// WEBPACK FOOTER //
// ./~/@dp/util-m-view-push/src/viewPush.js